import { notification, Modal } from 'antd';
import {
  searchShopLogById
} from '../services/api';
import router from 'umi/router';

export default {
  namespace: 'shoplog',
  state: {
    searchFilter: {
      type: 'dpId',
      key: '',
      pageNo: 1,
      pageSize: 10
    },
    shopLogs: {},
  },
  effects: {
    *searchShopLogById({ payload }, { call, put, select }) {
      const response = yield call(searchShopLogById, payload);
      if (response) {
        response.logResult = response.logResult || {};
        const { logResult } = response;
        if(payload.pageNo > 1) {
          const currentShopLogs = yield select(state => state.shoplog.shopLogs);
          let { data } = currentShopLogs.logResult || {};//当前state中的日志数据
          // 加载更多日志，和当前日志数据进行合并
          response.logResult.data = (data || []).concat(logResult.data || []);
        }
        yield put({
          type: 'setShopLogs',
          payload: response ? response : {},
        });
        yield put({//请求成功后设置当前的pageNo
          type: 'setSearchFilter',
          payload: {
            pageNo: payload.pageNo
          },
        });
      }
    },
  },
  reducers: {
    // 搜索门店相关
    setSearchFilter(state, action) {
      const { payload } = action;
      const { searchFilter } = state;
      return {
        ...state,
        searchFilter: {
          ...searchFilter,
          ...payload,
        },
      };
    },
    setShopLogs(state, action) {
      const shopLogs = action.payload;
      return {
        ...state,
        shopLogs,
      };
    },
  },
};
